/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: Date | string; output: Date; }
  DateTime: { input: Date; output: Date; }
  Long: { input: number; output: number; }
  UUID: { input: string; output: string; }
};

export type AssortmentMoq = {
  __typename?: 'AssortmentMoq';
  assortmentMoqNumber: Scalars['UUID']['output'];
  changedBy?: Maybe<Scalars['UUID']['output']>;
  changedDate?: Maybe<Scalars['Date']['output']>;
  changedDisplayName?: Maybe<Scalars['String']['output']>;
  changedEmail?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['UUID']['output'];
  createdDate: Scalars['Date']['output'];
  createdDisplayName: Scalars['String']['output'];
  createdEmail?: Maybe<Scalars['String']['output']>;
  isStandardRule: Scalars['Boolean']['output'];
  masterCategoryName?: Maybe<Scalars['String']['output']>;
  masterCategoryNumber?: Maybe<Scalars['String']['output']>;
  productLineName?: Maybe<Scalars['String']['output']>;
  productLineNumber?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
};

export type AssortmentMoqInput = {
  assortmentMoqNumber?: InputMaybe<Scalars['UUID']['input']>;
  brandNumber: Scalars['String']['input'];
  delete: Scalars['Boolean']['input'];
  masterCategoryNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productLineNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quantity: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type Brand = {
  __typename?: 'Brand';
  brandName: Scalars['String']['output'];
  brandNumber: Scalars['String']['output'];
};

/** One length in the save request. */
export type BrandLengthSelectionInput = {
  /** Delete flag. */
  isDeleted: Scalars['Boolean']['input'];
  /** Length number. */
  number: Scalars['Long']['input'];
};

/** One available length. */
export type Length = {
  __typename?: 'Length';
  lengthName: Scalars['String']['output'];
  lengthNumber: Scalars['String']['output'];
};

/** Length row for a brand. */
export type LengthBrand = {
  __typename?: 'LengthBrand';
  /** True when this length is inactive for the brand. */
  isDeleted: Scalars['Boolean']['output'];
  /** Length name. */
  name: Scalars['String']['output'];
  /** Length number. */
  number: Scalars['Long']['output'];
};

export type Level = {
  __typename?: 'Level';
  levelName: Scalars['String']['output'];
  levelNumber: Scalars['Long']['output'];
};

export type MasterStyleGroupWithSubgroup = {
  __typename?: 'MasterStyleGroupWithSubgroup';
  disableCategory: Scalars['Boolean']['output'];
  masterStyleGroupName: Scalars['String']['output'];
  masterStyleGroupNumber: Scalars['String']['output'];
  subCategories: Array<MasterStyleSubgroup>;
};

export type MasterStyleSubgroup = {
  __typename?: 'MasterStyleSubgroup';
  masterStyleGroupName: Scalars['String']['output'];
  masterStyleGroupNumber: Scalars['String']['output'];
  masterStyleSubgroupName: Scalars['String']['output'];
  masterStyleSubgroupNumber: Scalars['String']['output'];
};

export type MasterStyleSubgroupInput = {
  masterStyleGroupNumber: Scalars['String']['input'];
  masterStyleSubgroupNumber: Scalars['String']['input'];
};

export type MeetingSampleStyleInput = {
  masterStyleCategoryNumber: Scalars['String']['input'];
  productLineNumber: Scalars['String']['input'];
  styleNumber: Scalars['Long']['input'];
};

export type MeetingSampleTemplate = {
  __typename?: 'MeetingSampleTemplate';
  changedByName?: Maybe<Scalars['String']['output']>;
  changedDate?: Maybe<Scalars['Date']['output']>;
  createdByName: Scalars['String']['output'];
  createdDate: Scalars['Date']['output'];
  masterStyleCategories: Array<MasterStyleGroupWithSubgroup>;
  meetingSampleTemplateName?: Maybe<Scalars['String']['output']>;
  meetingSampleTemplateNumber: Scalars['UUID']['output'];
  productLines: Array<ProductLine>;
  sizes: Array<SizeMapping>;
};

export type MeetingSampleTemplateGroup = {
  __typename?: 'MeetingSampleTemplateGroup';
  meetingSampleTypeTemplates: Array<MeetingSampleTemplate>;
  sizeType: SizeType;
};

export type MeetingSampleTemplateInput = {
  brandNumber: Scalars['String']['input'];
  changedBy: Scalars['UUID']['input'];
  isDeleted: Scalars['Boolean']['input'];
  productLineNumbers: Array<Scalars['String']['input']>;
  sizeTypeNumber: Scalars['UUID']['input'];
  sizeTypeTemplateNumber?: InputMaybe<Scalars['UUID']['input']>;
  sizes: Array<SizeInput>;
  subcategoriesAndCategoryNumbers: Array<MasterStyleSubgroupInput>;
};

export type MoreSustainableChoice = {
  __typename?: 'MoreSustainableChoice';
  commercialText?: Maybe<Scalars['String']['output']>;
  isQualityBasedChoice: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  number: Scalars['Long']['output'];
  supportText?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  saveAssortmentMoq?: Maybe<Scalars['String']['output']>;
  /**
   * Save the selected lengths for a brand and return the saved values.
   * The returned lengths in the response maintain the order of the inputs provided in the request selection list.
   */
  saveBrandLengths: SaveBrandLengthsResponse;
  saveMeetingSampleTemplate?: Maybe<Scalars['String']['output']>;
  savePurchaseDivision?: Maybe<PurchaseDivision>;
  saveSizeTypeTemplate?: Maybe<Scalars['String']['output']>;
};


export type MutationSaveAssortmentMoqArgs = {
  assortmentMoqInput: AssortmentMoqInput;
};


export type MutationSaveBrandLengthsArgs = {
  input: SaveBrandLengthsInput;
};


export type MutationSaveMeetingSampleTemplateArgs = {
  meetingSampleInput: MeetingSampleTemplateInput;
};


export type MutationSavePurchaseDivisionArgs = {
  purchaseDivisionInput: PurchaseDivisionInput;
};


export type MutationSaveSizeTypeTemplateArgs = {
  sizeTypeGroupInput: SizeTypeTemplateInput;
};

export type ProductLine = {
  __typename?: 'ProductLine';
  productLineName: Scalars['String']['output'];
  productLineNumber: Scalars['String']['output'];
};

export type PurchaseDivision = {
  __typename?: 'PurchaseDivision';
  changedBy?: Maybe<User>;
  changedDate?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<User>;
  createdDate?: Maybe<Scalars['Date']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  purchaseDivisionName?: Maybe<Scalars['String']['output']>;
  purchaseDivisionNumber: Scalars['Long']['output'];
};

export type PurchaseDivisionInput = {
  brandNumber: Scalars['String']['input'];
  isDeleted: Scalars['Boolean']['input'];
  purchaseDivisionName: Scalars['String']['input'];
  purchaseDivisionNumber?: InputMaybe<Scalars['Long']['input']>;
  userEmail: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  assortmentMoqs?: Maybe<Array<AssortmentMoq>>;
  categoriesWithSubCategoriesAvailableInSizeType?: Maybe<Array<MasterStyleGroupWithSubgroup>>;
  /** Get the existing meeting sample templates */
  findMeetingSampleTemplates?: Maybe<Array<MeetingSampleTemplateGroup>>;
  /** Get the amount of meeting sample and sizes for a list of styles */
  findMeetingSampleTemplatesForStyles: Array<StyleMeetingSampleTemplate>;
  findSizeTypeGroups?: Maybe<Array<SizeTypeGroup>>;
  findSizeTypeGroupsByProductLineAndSubcategory?: Maybe<Array<SizeTypeGroup>>;
  findSizeTypes?: Maybe<Array<SizeType>>;
  lengthAvailable: Array<Maybe<Length>>;
  /**
   * Get all lengths for a brand, including deleted ones.
   * The returned lengths are sorted by length name in ascending order.
   */
  lengths: Array<LengthBrand>;
  levels: Array<Level>;
  moreSustainableChoices: Array<MoreSustainableChoice>;
  newBasicData: Array<Maybe<NewBasicData>>;
  purchaseDivisions?: Maybe<Array<PurchaseDivision>>;
  sendSizeTypeByIdsToCDC: Scalars['String']['output'];
  styleAttributeList: StyleAttributeList;
};


export type QueryAssortmentMoqsArgs = {
  brandNumber: Scalars['String']['input'];
};


export type QueryCategoriesWithSubCategoriesAvailableInSizeTypeArgs = {
  sizeTypeNumber: Scalars['UUID']['input'];
};


export type QueryFindMeetingSampleTemplatesArgs = {
  brandNumber: Scalars['String']['input'];
  filters?: InputMaybe<TemplateFilter>;
};


export type QueryFindMeetingSampleTemplatesForStylesArgs = {
  styleInput: Array<StyleInput>;
};


export type QueryFindSizeTypeGroupsArgs = {
  brandNumber: Scalars['String']['input'];
};


export type QueryFindSizeTypeGroupsByProductLineAndSubcategoryArgs = {
  masterStyleSubgroupNumber: Scalars['String']['input'];
  productLineNumber: Scalars['String']['input'];
};


export type QueryFindSizeTypesArgs = {
  brandNumber: Scalars['String']['input'];
};


export type QueryLengthAvailableArgs = {
  brandNumber: Scalars['String']['input'];
  masterStyleSubcategory: Scalars['String']['input'];
};


export type QueryLengthsArgs = {
  brandNumber: Scalars['String']['input'];
};


export type QueryMoreSustainableChoicesArgs = {
  sortBy?: InputMaybe<SortByInput>;
};


export type QueryNewBasicDataArgs = {
  brandNumber: Scalars['String']['input'];
};


export type QueryPurchaseDivisionsArgs = {
  brandNumber: Scalars['String']['input'];
};


export type QuerySendSizeTypeByIdsToCdcArgs = {
  sizeTypeIds: Array<Scalars['Long']['input']>;
};


export type QueryStyleAttributeListArgs = {
  closureNumber?: InputMaybe<Scalars['Long']['input']>;
  fitNumber?: InputMaybe<Scalars['Long']['input']>;
  masterStyleSubcategoryAttribute: Scalars['String']['input'];
  neckNumber?: InputMaybe<Scalars['Long']['input']>;
  sleeveNumber?: InputMaybe<Scalars['Long']['input']>;
};

/** Input for saving brand lengths. */
export type SaveBrandLengthsInput = {
  /** Brand number. */
  brandNumber: Scalars['String']['input'];
  /** Lengths to save. */
  lengths: Array<BrandLengthSelectionInput>;
  /** Email of the user making the change. */
  userEmail: Scalars['String']['input'];
};

/** Result after saving brand lengths. */
export type SaveBrandLengthsResponse = {
  __typename?: 'SaveBrandLengthsResponse';
  /** Brand number. */
  brandNumber: Scalars['String']['output'];
  /**
   * Saved lengths.
   * The returned lengths maintain the order of the inputs provided in the request selection list.
   */
  lengths: Array<LengthBrand>;
};

export type Size = {
  __typename?: 'Size';
  sizeName: Scalars['String']['output'];
  sizeNumber: Scalars['String']['output'];
};

export type SizeInput = {
  lengthNumber?: InputMaybe<Scalars['Long']['input']>;
  quantity: Scalars['Long']['input'];
  sizeNumber: Scalars['Long']['input'];
};

export type SizeMapping = {
  __typename?: 'SizeMapping';
  length?: Maybe<Length>;
  quantity: Scalars['Long']['output'];
  size?: Maybe<Size>;
};

export type SizeType = {
  __typename?: 'SizeType';
  sizeTypeName: Scalars['String']['output'];
  sizeTypeNumber: Scalars['UUID']['output'];
  sizeTypeSizes: Array<Size>;
};

export type SizeTypeGroup = {
  __typename?: 'SizeTypeGroup';
  sizeType: SizeType;
  sizeTypeTemplates: Array<SizeTypeTemplate>;
};

export type SizeTypeTemplate = {
  __typename?: 'SizeTypeTemplate';
  changedBy?: Maybe<Scalars['UUID']['output']>;
  changedDate?: Maybe<Scalars['String']['output']>;
  changedDisplayName?: Maybe<Scalars['String']['output']>;
  changedEmail?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['UUID']['output'];
  createdDate: Scalars['String']['output'];
  createdDisplayName: Scalars['String']['output'];
  createdEmail?: Maybe<Scalars['String']['output']>;
  sizeTypeTemplateName: Scalars['String']['output'];
  sizeTypeTemplateNumber: Scalars['UUID']['output'];
  sizeTypeTemplateProductLines: Array<ProductLine>;
  sizeTypeTemplateSizes: Array<Size>;
  sizeTypeTemplateSubcategories: Array<MasterStyleSubgroup>;
};

export type SizeTypeTemplateInput = {
  brandNumber: Scalars['String']['input'];
  changedBy: Scalars['UUID']['input'];
  isDeleted: Scalars['Boolean']['input'];
  productLineNumbers: Array<Scalars['String']['input']>;
  sizeTypeNumber: Scalars['UUID']['input'];
  sizeTypeTemplateNumber?: InputMaybe<Scalars['UUID']['input']>;
  sizesNumbers: Array<Scalars['String']['input']>;
  subcategoriesAndCategoryNumbers: Array<MasterStyleSubgroupInput>;
};

export type SortByInput = {
  sortByAttribute?: InputMaybe<Scalars['String']['input']>;
  sortByDirection?: InputMaybe<Scalars['String']['input']>;
};

export type StyleAttribute = {
  __typename?: 'StyleAttribute';
  isValid: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  number: Scalars['Long']['output'];
};

export type StyleAttributeList = {
  __typename?: 'StyleAttributeList';
  closures?: Maybe<Array<StyleAttribute>>;
  fits?: Maybe<Array<StyleAttribute>>;
  necks?: Maybe<Array<StyleAttribute>>;
  sleeves?: Maybe<Array<StyleAttribute>>;
};

export type StyleInput = {
  masterStyleSubCategoryNumber: Scalars['String']['input'];
  productLineNumber: Scalars['String']['input'];
  styleNumber: Scalars['Long']['input'];
};

export type StyleMeetingSampleTemplate = {
  __typename?: 'StyleMeetingSampleTemplate';
  sizeMapping?: Maybe<Array<SizeMapping>>;
  styleNumber: Scalars['Long']['output'];
};

export type TemplateFilter = {
  masterStyleCategoryNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  productLineNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  sizeNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  sizeTypeNumbers?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  userNumber?: Maybe<Scalars['String']['output']>;
};

export type NewBasicData = {
  __typename?: 'newBasicData';
  masterCategoryNames: Array<Maybe<Scalars['String']['output']>>;
  masterSubCategoryNames: Array<Maybe<Scalars['String']['output']>>;
  productLineNames: Array<Maybe<Scalars['String']['output']>>;
  sizeNames: Array<Maybe<Scalars['String']['output']>>;
  sizeTypeNames: Array<Maybe<Scalars['String']['output']>>;
};

export type GetMeetingSampleTemplatesForStylesQueryVariables = Exact<{
  styleInput: Array<StyleInput> | StyleInput;
}>;


export type GetMeetingSampleTemplatesForStylesQuery = { __typename?: 'Query', findMeetingSampleTemplatesForStyles: Array<{ __typename?: 'StyleMeetingSampleTemplate', styleNumber: number, sizeMapping?: Array<{ __typename?: 'SizeMapping', quantity: number, size?: { __typename?: 'Size', sizeNumber: string, sizeName: string } | null, length?: { __typename?: 'Length', lengthNumber: string, lengthName: string } | null }> | null }> };


export const GetMeetingSampleTemplatesForStylesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMeetingSampleTemplatesForStyles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"styleInput"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StyleInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findMeetingSampleTemplatesForStyles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"styleInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"styleInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleNumber"}},{"kind":"Field","name":{"kind":"Name","value":"sizeMapping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sizeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"sizeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"length"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lengthNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lengthName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMeetingSampleTemplatesForStylesQuery, GetMeetingSampleTemplatesForStylesQueryVariables>;